import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import BaseRoute from './base-route.gjs';
import Component from '@glimmer/component';
import ConversationMemberListItem from '../conversation-member-list-item.gjs';
import GhostButton from 'ember-simplepractice/components/spds/action/button/ghost';
import styles from './conversation-details.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class MessagingRoutesConversationDetails extends Component {
  @service messagingNavigation;

  get routeHandler() {
    return this.args.handler;
  }

  get conversation() {
    return this.routeHandler.conversation;
  }

  get isDraft() {
    return this.routeHandler.isDraft;
  }

  get showModifyMembers() {
    return this.isDraft;
  }

  get members() {
    return this.routeHandler.members;
  }

  onNameClickFor = member => {
    if (!this.routeHandler.canNavigateToClientProfile(member)) {
      return undefined;
    }

    return () => {
      document.activeElement.blur();
      this.routeHandler.navigateToClientProfile.perform(member);
    };
  };

  goBack = async () => {
    await this.messagingNavigation.leaveChildRoute();
  };

  onModifyMembers = () => {};

  <template>
    <BaseRoute
      class="{{styles.component}} conversation-details-page"
      data-test-conversation-details-route
    >
      <:header>
        <GhostButton
          @fitContent={{true}}
          @iconOnly={{true}}
          {{on "click" this.goBack}}
          class="back-button"
          data-test-conversation-details-page-back-button
        >
          {{svgJar "messaging-chevron-left"}}
        </GhostButton>

        <span class="title">{{t "emc.conversation_details.title"}}</span>
      </:header>
      <:default>
        <div class="members-section-header" data-test-members-section-header>
          <h2 class="members-section-title" data-test-members-section-title>
            {{t "emc.conversation_details.members_section" count=this.members.length}}
          </h2>

          {{#if this.showModifyMembers}}
            <GhostButton @size="small" {{on "click" this.onModifyMembers}} data-test-modify-members>
              {{svgJar "messaging-users"}}
              {{t "emc.draft_conversation_banner.modify_members"}}
            </GhostButton>
          {{/if}}
        </div>

        <ul class="members-list" data-test-members-list role="list">
          {{#each this.members as |member|}}
            <ConversationMemberListItem
              @member={{member}}
              @onNameClick={{this.onNameClickFor member}}
            />
          {{/each}}
        </ul>
      </:default>
    </BaseRoute>
  </template>
}
